import { hexToRgb } from '../theme-tools';
const TRANSPARENT = 'transparent';
const BLACK = '#000';
const WHITE = '#fff';
const NOTIFICATION_CIRCLE_DEFAULT = '#3b80ab'; // blue: 'rgb(59,128,171)'
const NOTIFICATION_CIRCLE_OTHER = '#4ea359'; // green: 'rgb(78,163,90)'
const MENTION_BG = '#d3e1eb';
const primaries = ['green', 'orange', 'purple', 'bw'];
const getCustomTheme = colors => {
  // baseColors used but not exported
  const baseColors = {
    base: {
      bg: WHITE,
      border: TRANSPARENT,
      text: colors[primaries[3]].darkest,
      // BLACK,
      icon: WHITE,
      hover: {
        bg: colors[primaries[2]].lightest
      }
    },
    contrast: {
      bg: BLACK,
      text: WHITE,
      border: WHITE
    }
  };
  const themeColors = {
    ...baseColors,
    ...colors
  };
  return {
    activities: {
      bg: themeColors[primaries[3]].light9
    },
    activity: {
      bg: themeColors[primaries[3]].lightest,
      text: themeColors[primaries[2]].primary,
      border: themeColors[primaries[2]].primary,
      notificationType: {
        circle: themeColors.hyperlink,
        icon: themeColors[primaries[3]].lightest
      },
      attentionNeeded: themeColors.hyperlink,
      timestamp: themeColors[primaries[3]].light4,
      read: themeColors[primaries[3]].lightest,
      unread: themeColors[primaries[3]].light9,
      markAsRead: themeColors[primaries[0]].light2,
      dismissal: themeColors[primaries[3]].light7,
      link: themeColors.hyperlink,
      readItem: themeColors[primaries[3]].light8,
      selectedFilter: themeColors[primaries[3]].light8,
      notificationTypeText: themeColors[primaries[3]].light6
    },
    badge: {
      circle: themeColors[primaries[2]].light4,
      icon: themeColors[primaries[3]].lightest
    },
    banner: {
      bg: 'warning.500',
      text: WHITE,
      close: {
        bg: BLACK,
        icon: WHITE
      }
    },
    chooseCategory: {
      bg: themeColors[primaries[0]].light6
    },
    changeCategory: {
      bg: themeColors[primaries[0]].light6,
      message: themeColors.necessity
    },
    createEditButton: {
      avatar: {
        icon: themeColors[primaries[3]].light9,
        highlight: themeColors[primaries[3]].light8
      },
      shield: {
        icon: themeColors[primaries[0]].dark1
      },
      container: {
        bg: themeColors[primaries[3]].lightest
      },
      bg: WHITE,
      border: themeColors[primaries[3]].lightest
    },
    createMessageBox: {
      border: themeColors[primaries[3]].light8,
      circle: themeColors[primaries[0]].dark4,
      icon: themeColors[primaries[3]].light9
    },
    postModal: {
      clearContents: themeColors[primaries[3]].light7
    },
    editBox: {
      text: themeColors[primaries[3]].light7
    },
    flagPost: {
      message: themeColors.necessity
    },
    forum: {
      safearea: {
        bg: themeColors[primaries[2]].primary
      },
      maincontainer: {
        bg: WHITE
      }
    },
    forumHomeScreen: {
      bg: themeColors.base.bg,
      infoText: themeColors[primaries[3]].light4,
      header: {
        border: themeColors[primaries[3]].light7
      }
    },
    goBackButton: {
      text: themeColors[primaries[2]].primary,
      icon: themeColors[primaries[2]].primary
    },
    interactionBar: {
      bg: {
        default: WHITE,
        highlight: themeColors[primaries[2]].lightest
      },
      liked: {
        icon: {
          active: themeColors[primaries[2]].primary,
          default: themeColors[primaries[3]].darkest
        }
      },
      watching: {
        icon: {
          active: themeColors.necessity,
          default: themeColors[primaries[3]].darkest
        }
      }
    },
    login: {
      heading: {
        text: themeColors.base.text
      }
    },
    menu: {
      top: {
        bg: themeColors[primaries[2]].lightest
      },
      channels: {
        bg: `rgba(${hexToRgb(themeColors[primaries[3]].light1)},0.6)`
      },
      channel: {
        default: {
          bg: themeColors.base.bg,
          border: themeColors.base.border,
          name: themeColors.base.text
        },
        selected: {
          bg: themeColors[primaries[2]].lightest,
          border: themeColors[primaries[2]].primary,
          name: themeColors[primaries[2]].primary
        },
        box: {
          border: themeColors[primaries[3]].light9,
          bg: {
            default: themeColors.base.bg,
            selected: themeColors[primaries[3]].light8
          }
        },
        text: {
          name: {
            default: themeColors[primaries[3]].light9,
            selected: themeColors[primaries[2]].primary
          }
        },
        mobile: {
          name: themeColors.contrast.text
        }
      },
      header: {
        newTopic: {
          bg: themeColors.base.bg,
          border: themeColors[primaries[2]].primary,
          text: themeColors[primaries[2]].primary,
          hover: {
            bg: themeColors.base.hover.bg
          }
        },
        button: {
          border: '#ccc',
          icon: {
            bg: WHITE,
            // themeColors.base.icon,
            text: themeColors.base.text
          }
        }
      },
      links: {
        icon: themeColors[primaries[3]].light5,
        text: themeColors.base.text
      }
    },
    message: {
      box: {
        bg: themeColors[primaries[3]].lightest
      },
      poster: {
        circle: {
          default: themeColors.hyperlink,
          found: themeColors.necessity
        },
        name: themeColors[primaries[3]].lightest
      },
      created: themeColors[primaries[3]].light4,
      last: themeColors[primaries[3]].light4,
      unseen: {
        default: themeColors[primaries[3]].light8,
        selected: themeColors.hyperlink
      }
    },
    messages: {
      box: {
        bg: themeColors[primaries[3]].light9
      },
      circle: themeColors[primaries[2]].primary,
      icon: themeColors.base.icon
    },
    modal: {
      bg: WHITE
    },
    moreActions: {
      change: themeColors.necessity,
      delete: themeColors.necessity,
      pin: themeColors.necessity,
      moderator: {
        bg: themeColors[primaries[0]].light9
      }
    },
    movePost: {
      bg: {
        default: themeColors.base.bg,
        selected: themeColors[primaries[0]].light6
      },
      text: {
        default: themeColors.base.text,
        selected: themeColors.contrast.text
      }
    },
    newReplyBox: {
      text: themeColors[primaries[3]].light7
    },
    notification: {
      bg: {
        tab: themeColors[primaries[0]].primary,
        indicator: themeColors[primaries[1]].primary
      },
      text: themeColors[primaries[3]].light9,
      circle: {
        notification: NOTIFICATION_CIRCLE_DEFAULT,
        other: NOTIFICATION_CIRCLE_OTHER
      },
      icon: themeColors.base.icon
    },
    overview: {
      bg: themeColors[primaries[3]].lightest,
      button: {
        bg: themeColors[primaries[3]].light1
      },
      icon: themeColors.base.icon,
      channel: {
        name: themeColors.contrast.text
      }
    },
    privateMessage: {
      box: {
        bg: themeColors[primaries[3]].lightest
      },
      user: {
        name: themeColors[primaries[3]].lightest,
        found: themeColors.necessity,
        notFound: themeColors.hyperlink
      },
      yours: {
        border: themeColors[primaries[0]].light6,
        bg: themeColors[primaries[0]].light9
      },
      notYours: {
        border: themeColors[primaries[3]].light6,
        bg: themeColors[primaries[3]].light8
      },
      created: themeColors[primaries[3]].light4,
      content: themeColors[primaries[3]].light4
    },
    profile: {
      icon: themeColors[primaries[3]].light9,
      message: themeColors.necessity,
      signOut: {
        bg: themeColors.necessity,
        text: themeColors[primaries[3]].lightest
      }
    },
    reply: {
      avatar: {
        circle: themeColors.necessity,
        icon: themeColors[primaries[3]].light9
      },
      moderator: {
        icon: themeColors[primaries[0]].dark1
      },
      border: themeColors[primaries[3]].light7,
      unique: {
        bg: themeColors[primaries[2]].lightest,
        border: themeColors[primaries[2]].primary
      },
      human: {
        default: themeColors[primaries[0]].light8,
        created: themeColors.base.bg
      },
      text: {
        cooked: themeColors[primaries[3]].light4,
        created: themeColors[primaries[3]].light4,
        content: themeColors[primaries[3]].light4
      },
      flagged: {
        icon: themeColors[primaries[1]].light4,
        text: themeColors[primaries[3]].light4
      },
      bg: {
        default: WHITE,
        highlight: themeColors[primaries[2]].lightest
      }
    },
    replies: {
      bg: {
        default: themeColors[primaries[3]].lightest
      }
    },
    resultItem: {
      bg: {
        default: themeColors.base.bg,
        active: themeColors[primaries[0]].light6
      },
      created: themeColors[primaries[3]].light4,
      name: themeColors.hyperlink,
      liked: themeColors[primaries[2]].primary,
      notliked: themeColors[primaries[3]].darkest,
      icon: {
        period: themeColors[primaries[3]].light6,
        chevron: themeColors.hyperlink
      }
    },
    search: {
      input: {
        bg: themeColors.base.bg,
        invalid: themeColors.necessity
      },
      clear: themeColors[primaries[3]].light4,
      categoryText: themeColors.base.icon
    },
    searchModal: {
      input: {
        border: themeColors.hyperlink,
        invalid: themeColors.necessity
      },
      select: {
        bg: themeColors[primaries[2]].primary
      },
      viewAll: {
        border: themeColors[primaries[2]].primary,
        text: themeColors[primaries[2]].primary
      }
    },
    searchResult: {
      bg: themeColors.base.icon,
      header: themeColors.base.icon,
      input: {
        border: themeColors[primaries[3]].light4,
        invalid: themeColors.necessity
      },
      select: {
        bg: themeColors[primaries[2]].primary,
        text: themeColors.base.icon
      }
    },
    searchRecipient: {
      box: {
        border: themeColors[primaries[3]].light6
      },
      message: themeColors.necessity,
      divider: themeColors[primaries[3]].light8,
      input: {
        border: TRANSPARENT,
        outline: TRANSPARENT,
        bg: TRANSPARENT
      }
    },
    searchResultItem: {
      box: {
        bg: WHITE
      },
      moderator: themeColors[primaries[0]].primary,
      circle: {
        user: themeColors.necessity,
        dots: themeColors.hyperlink
      },
      icon: themeColors[primaries[3]].light9,
      categoryName: themeColors.hyperlink,
      link: themeColors.hyperlink,
      created: themeColors[primaries[3]].light6
    },
    spinner: themeColors[primaries[3]].primary,
    textComponent: {
      bg: themeColors.contrast.bg,
      text: themeColors.contrast.text
    },
    topic: {
      pinned: themeColors.necessity,
      text: {
        name: themeColors.hyperlink,
        created: themeColors[primaries[3]].light4,
        activated: themeColors[primaries[3]].light4,
        category: {
          name: themeColors.hyperlink,
          created: themeColors[primaries[3]].light4
        },
        title: themeColors[primaries[3]].light7,
        content: themeColors[primaries[3]].light7
      },
      box: {
        bg: WHITE,
        border: themeColors[primaries[3]].light7
      },
      heart: {
        circle: themeColors[primaries[2]].primary,
        icon: themeColors[primaries[3]].light9
      },
      createButton: {
        bg: themeColors[primaries[3]].lightest,
        // themeColors[primaries[2]].primary,
        text: themeColors[primaries[3]].light3,
        // themeColors.contrast.text
        border: themeColors[primaries[3]].light7
      },
      bg: {
        default: WHITE,
        highlight: themeColors[primaries[2]].lightest
      }
    },
    userProfileModal: {
      avatar: {
        bg: themeColors[primaries[3]].light9,
        icon: themeColors[primaries[3]].light7
      },
      footer: {
        border: themeColors[primaries[3]].light9
      },
      button: {
        bg: themeColors[primaries[3]].lightest,
        hover: themeColors[primaries[3]].light9
      }
    },
    mention: {
      bg: MENTION_BG,
      fontColor: BLACK
    }
  };
};
export { getCustomTheme };
//# sourceMappingURL=theme.js.map